import 'core-js/stable';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';

import Cookies from 'universal-cookie';

import FsokNext from './FsokNext';

import { storageKeys } from './common/lib/storage';
import './default.css';
import './fonts/apex-new.css';
import './fonts/nunito-sans.css';
import { Environment } from './types/Environment';

const cookies = new Cookies();
cookies.set('Source', 'fsok-next', { path: '/fsok' });

const root = document.querySelector('#root');

if (process.env.NODE_ENV === 'development') {
  window.fsokConfig = {
    showKundmarke: 'true',
    kundmarkeIsRequired: 'true',
    agarforteckningServiceUrl: '',
    aktServiceUrl: '',
    kartstodTyp: 'PREMIUM',
    maxAntalFastigheterAgarforteckning: 500,
    wfsHost: '',
    wmsHost: '',
    environment: Environment.Local,
  };
}

window.localStorage.setItem('storageKeys', JSON.stringify(storageKeys));

if (root) {
  ReactDOM.render(
    <React.StrictMode>
      <FsokNext />
    </React.StrictMode>,
    root
  );
}
